import React, {useState} from "react";
import {composeValidators, limit, required} from "../../helpers/ValidateHelper";
import {useSelector} from "react-redux";
import OtherField from "../fields/OtherField";
import {Field, useForm} from "react-final-form";
import SelectField from "../fields/SelectField";
import Error from "../fields/Error";
import {filterOption} from "../../helpers/OptionHelper";
import useSyncedField from "../../hooks/useSyncedField";

function TypeOfPaper() {
    const options = useSelector(state => state.orderOptions.data.typeOfPaper);
    const otherOption = options[options.length - 1];
    const [allOptions, setOptions] = useState(options);

    useSyncedField('typeOfPaper', 'string');
    useSyncedField('typeOfPaperOther', 'string');

    const {change} = useForm();

    const filterAllOptions = rawInput => {
        const filteredOptions = filterOption(options, rawInput);
        if (filteredOptions.length === 0) {
            filteredOptions.push(otherOption);
        }
        setOptions(filteredOptions);
    };

    return <div className="form-group dd-form-group">
        <div className="form-label">Type of paper <span className="rq">*</span></div>
        <Field
            name="typeOfPaper"
            component={SelectField}
            isSearchable={true}
            options={allOptions}
            disableDefaultFilter={true}
            onInputChange={filterAllOptions}
            validate={required('Please specify type paper type')}
            onChange={value => {
                if (value && !allOptions.some(paper => String(paper.value) === String(value))) {
                    change('typeOfPaper', 'Other');
                    change('typeOfPaperOther', value);
                } else {
                    change('typeOfPaper', value);
                }
            }}
        />
        <Error name="typeOfPaper"/>
        <OtherField
            name="typeOfPaperOther"
            watch="typeOfPaper"
            validate={composeValidators(
                required('Please specify type paper type'),
                limit('Maximum {limit} characters allowed. You\'ve used {count}.', 255)
            )}
        />
    </div>
}

export default TypeOfPaper;
